
    import { thresholdExplorerModule } from "./src/education/thresholdExplorer.js";
    const mount = document.getElementById("threshold-explorer-mount");
    if (mount) {
      thresholdExplorerModule.mount(mount);
    }
  